import { isEmpty } from 'lodash'

export function rankingPreferencesHelper({
  conversionType = '',
  instrumentIds = [],
  preselectedFundingOption = {},
} = {}) {
  if (
    isEmpty(preselectedFundingOption) &&
    instrumentIds.length === 0 &&
    !conversionType
  ) {
    return null
  }

  const ranking = {}
  if (!isEmpty(preselectedFundingOption)) {
    ranking.preselected_funding_option_id = preselectedFundingOption.id
  }
  if (instrumentIds.length > 0) {
    ranking.instrument_ids = instrumentIds
  }
  if (conversionType) {
    const currencyConversionType =
      conversionType === 'EXTERNAL' ? 'ISSUER' : 'PAYPAL'
    ranking.currency_conversion_type = currencyConversionType
  }

  return { ranking }
}
